
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb35c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb35c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $783bb243ba935ff6$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["9vqfN","index.d88f6140.js","65arK","solana.48916c1a.png","iYJN1","solanaWhite.818ef9a8.png","65xYx","ethActive.4970d565.png","bEqZ8","userImage.e8c1c4a9.png","l8BwX","mbLogo.fb33974a.png","kGqup","boxIcon.300a7b44.png","4vKsr","boostedFrame.73be0b81.svg","qIqMU","infoIcon.3098f0ae.png","8Qmnn","stakingImage.7ac9b17c.svg","k6y31","shroomBg.829adfab.svg","kN1px","viewStake.28ed769b.png","5UtTU","dollars.179a5d4d.svg","3bFcD","sampleMush.3c5f767c.png","1b11S","solMb.801b0992.gif","jHAer","boostImage.537b912c.svg","fQhuF","tensorIcon.6c0a417e.svg","9yeCe","blurIcon.92f8413b.svg","3t0ZX","dollars2.b92bd067.svg","7XvJy","everydayMushImage.b371dce1.svg","8ewEo","shroomImage.60ca5ec9.svg","8SPxg","ethGray.5b99d55d.svg","8LiuW","solanaGray.97b840a3.svg","hp2O3","index.ecf69186.css"]'));


//# sourceMappingURL=index.runtime.1b962b60.js.map
